import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = ({ darkMode = false }) => {
    const { i18n } = useTranslation();

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };

    const currentLanguage = i18n.language || 'tr';

    const baseClass = "flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold tracking-wide transition-all";
    
    const activeClass = "bg-blue-600 text-white shadow-sm";
    
    const inactiveClass = darkMode
        ? "text-slate-300 hover:text-white hover:bg-white/10"
        : "text-gray-600 hover:text-gray-900 hover:bg-gray-100/50";

    const wrapperClass = darkMode
        ? "flex items-center gap-2 bg-slate-900/60 backdrop-blur-md border border-slate-800 rounded-full p-1 shadow-lg transition-all"
        : "flex items-center gap-2 bg-white/60 backdrop-blur-md border border-gray-200/80 rounded-full p-1 shadow-sm transition-all";

    return (
        <div className={wrapperClass}>
            <button
                onClick={() => changeLanguage('tr')}
                className={`${baseClass} ${currentLanguage.startsWith('tr') ? activeClass : inactiveClass}`}
            >
                <span className="text-sm">🇹🇷</span>
                <span>TR</span>
            </button>
            <button
                onClick={() => changeLanguage('en')}
                className={`${baseClass} ${currentLanguage.startsWith('en') ? activeClass : inactiveClass}`}
            >
                <span className="text-sm">🇬🇧</span>
                <span>EN</span>
            </button>
        </div>
    );
};

export default LanguageSwitcher;
